import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CmsCardContainer from '@components/CmsCardContainer/CmsCardContainer';
import { selectContent } from '@store/selectors/cmsContent.selector';
import { fetchCmsContentAsync } from '@store/actions/cmsContent.actions';
import { CmsCardProps } from '@components/types';
import { AmplifyLogs, CodingConstants } from '@constants';
import { logUserEvent } from '@analytics/amplifyLogging';

const CmsContent: React.FC<CmsCardProps> = ({ contentId, handleEnrollNow, navigationType }) => {
    const dispatch = useDispatch();
    const cmsContent: string = useSelector(selectContent(contentId));
    const { authCashOut } = CodingConstants;

    const handleNavigation = () => {
        navigationType(authCashOut);
        logUserEvent({
            ...AmplifyLogs.CashOutWidgetGeneric
        });
    };

    useEffect(() => {
        document.getElementById('cashOutGetStarted')?.addEventListener('click', handleNavigation);
        document.getElementById('cashOutGetStartedMobile')?.addEventListener('click', handleNavigation);
        document.getElementById('enrollPaperless')?.addEventListener('click', handleEnrollNow);
    });

    useEffect(() => {
        dispatch(fetchCmsContentAsync.request(contentId));
    }, []);

    return <>{cmsContent && <CmsCardContainer id={contentId} content={cmsContent} />}</>;
};

export default React.memo(CmsContent);
